module.exports = __webpack_public_path__ + "img/sergeant-tips-icon4.6fa658eb.png";